module.exports = __webpack_public_path__ + "media/TheBloc_Alps_Intro_Intro_Companies.44eb8687.mp4";